"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppInsightsProvider = void 0;
var _applicationinsightsReactJs = require("@microsoft/applicationinsights-react-js");
var _react = require("react");
var _applicationInsights = require("../application-insights");
var _jsxRuntime = require("react/jsx-runtime");
var AppInsightsProvider = function(param) {
    var children = param.children;
    var _ref = _sliced_to_array((0, _react.useState)({
        reactPlugin: new _applicationinsightsReactJs.ReactPlugin()
    }), 2), appInsights = _ref[0], setAppInsights = _ref[1];
    (0, _react.useEffect)(function() {
        if (_applicationInsights.ApplicationInsights.isInitialized()) {
            setAppInsights({
                reactPlugin: (0, _applicationInsights.getApplicationInsightsReactPlugin)()
            });
        } else {
            // This could happen and we want to cover this case
            var _applicationInsights_ApplicationInsights_onInitialized = _applicationInsights.ApplicationInsights.onInitialized(function() {
                setAppInsights({
                    reactPlugin: (0, _applicationInsights.getApplicationInsightsReactPlugin)()
                });
            }), removeListener = _applicationInsights_ApplicationInsights_onInitialized.remove;
            return function() {
                removeListener();
            };
        }
        return function() {};
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_applicationinsightsReactJs.AppInsightsContext.Provider, {
        value: appInsights.reactPlugin,
        children: children
    });
};
exports.AppInsightsProvider = AppInsightsProvider; //# sourceMappingURL=AppInsightsProvider.js.map
